import { useState } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import Radio from 'components/ui-components/Radio';
import scrollElementIntoView from 'utils/scrollIntoView';

const AddressBookGrid = ({
  groupName,
  addressList,
  selectedAddress,
  setAddress,
  scrollRef,
  resetAddress,
  setResetAddress,
}) => {
  const [userSelectedAddress, setUserSelectedAddress] =
    useState(selectedAddress);

  const addresses =
    addressList && addressList.length > 0
      ? addressList.map(address => {
          const refactoredAddress = {
            id: address.id,
            name: address.name,
            line1: address.line_1,
            line2: address.line_2,
            line3: address.line_3,
            line4: address.line_4,
            line5: address.line_5,
            postcode: address.postcode,
          };

          const selected =
            JSON.stringify(refactoredAddress) ===
            JSON.stringify(userSelectedAddress);

          const addressLabel = (
            <>
              {address.name && (
                <span>
                  <strong>{address.name}</strong>
                </span>
              )}
              {address.line_1 && <span>{address.line_1}</span>}
              {address.line_2 && <span>{address.line_2}</span>}
              {address.line_3 && <span>{address.line_3}</span>}
              {address.postcode && <span>{address.postcode}</span>}
            </>
          );

          const handleSelectedRadio = () => {
            setUserSelectedAddress(refactoredAddress);
            setAddress(address);
            scrollElementIntoView(scrollRef);

            if (setResetAddress) {
              setResetAddress(false);
            }
          };

          const uniqueId = address.id + uuidv4(); // UUID necessary for multiple components in view

          return (
            <Radio
              key={uniqueId}
              id={uniqueId}
              name={groupName}
              multiline
              label={addressLabel}
              checked={!resetAddress && selected}
              onChange={handleSelectedRadio}
              className="address-book-grid__single-address"
            />
          );
        })
      : 'No Addresses Found';

  return <fieldset className="address-book-grid">{addresses}</fieldset>;
};

AddressBookGrid.propTypes = {
  groupName: PropTypes.string.isRequired,
  addressList: PropTypes.array.isRequired,
  selectedAddress: PropTypes.object.isRequired,
  setAddress: PropTypes.func.isRequired,
  scrollRef: PropTypes.object.isRequired,
  resetAddress: PropTypes.bool,
  setResetAddress: PropTypes.func,
};

export default AddressBookGrid;
